import styled from "styled-components";

export const IndicadorWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #BDE5F8;
  border: solid 1px #00529B;
  width: fit-content;
  margin: 15px auto;
  
  * {
    font-size: 24px;
    color: #00529B;
  }
  h2 {
    font-size: 16px;
    line-height: 30px;
    margin: 0 10px;
  }
`;